/**
 * The group's legal pages, linked from every public landing and bio page.
 *
 * They live on pamgolding.co.za and are deliberately linked, not copied: the
 * Pam Golding Group Privacy Statement covers every PGP company and
 * franchisee, so these pages are covered by it, and Legal maintains one copy.
 * The cookie policy is a section of the terms page.
 */

const SITE = 'https://www.pamgolding.co.za';

export const LEGAL_LINKS = {
  privacy: { label: 'Privacy policy', href: `${SITE}/privacy-policy` },
  terms: { label: 'Terms & conditions', href: `${SITE}/terms-and-conditions` },
  cookies: { label: 'Cookie policy', href: `${SITE}/terms-and-conditions#cookie-policy` },
  paia: { label: 'Access to information (PAIA)', href: `${SITE}/resources/docs/general/paia.pdf` },
  disclaimer: { label: 'Disclaimer', href: `${SITE}/disclaimer` },
};

/** Footer order. */
export const FOOTER_LEGAL_LINKS = [
  LEGAL_LINKS.privacy,
  LEGAL_LINKS.terms,
  LEGAL_LINKS.cookies,
  LEGAL_LINKS.paia,
  LEGAL_LINKS.disclaimer,
];
